import * as React from 'react';
import { Candidate } from '../../Model/Candidate';
import { Trans } from '../Trans';

export class YearOfBirth extends React.PureComponent<{ candidate: Candidate }> {
    public render() {
        const yearOfBirth = this.props.candidate.yearOfBirth;
        if (!yearOfBirth) {
            return null;
        }

        return <div className="year-of-birth">
            <h3><Trans>Jahrgang</Trans></h3>
            <p>{yearOfBirth}</p>
        </div>;
    }
}
